import React from 'react';
import Panel from './Panel';
import RegisterCompany from '../../components/Panel/RegisterCompany/RegisterCompany';

const RegisterCompanyPage = () => {

  return (
    <Panel>
      <div>
        <RegisterCompany />
      </div>
    </Panel>

  );
};

export default RegisterCompanyPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/RegisterCompanyPage.js
 **/